import FormField from './FormField';

export default function MultiSelect({
  label,
  options = [],
  selected = [],
  onChange,
  error,
  required,
  hint,
}) {
  function toggle(value) {
    const next = selected.includes(value)
      ? selected.filter(v => v !== value)
      : [...selected, value];
    onChange(next);
  }

  return (
    <FormField label={label} required={required} error={error} hint={hint}>
      <div className={`multi-select-container ${error ? 'error' : ''}`}>
        {options.length === 0 ? (
          <div className="multi-select-empty">No options available</div>
        ) : (
          options.map(opt => (
            <label key={opt.value} className="multi-select-item">
              <input
                type="checkbox"
                checked={selected.includes(opt.value)}
                onChange={() => toggle(opt.value)}
              />
              {opt.label}
            </label>
          ))
        )}
      </div>
    </FormField>
  );
}
